import ME from '../../assets/haoweiface.png'
import HeaderSocials from './HeaderSocials'
import './header.css'
const Header = () => {
  return (
    <header>
      <div className="profile_card">
        <div className="me">
          <img src={ME} alt="Haowei Lou" />
        </div>
        <h1>Haowei Lou</h1>
        <p className="profile_role">PhD Candidate in Computer Science</p>
        <p className="profile_affiliation">UNSW Sydney</p>
        <p className="profile_location">Sydney, Australia</p>

        <HeaderSocials />

        <div className="profile_actions">
          <a href="mailto:louhaowei@gmail.com" className="btn">Email</a>
        </div>

        <div className="profile_focus">
          <span>GAI</span>
          <span>TTS</span>
          {/* <span>Singing Voice Generation</span> */}
          <span>BCI</span>
        </div>
      </div>
    </header>
  )
}

export default Header
